import { transEnum } from '@luminovo/commons';

import { AvailabilityType } from '@luminovo/http-client';
import { availabilityTypeTranslations } from '../i18n';

export function formatAvailabilityType(availability: AvailabilityType): string {
    return transEnum(availability, availabilityTypeTranslations);
}
